import { observer } from 'mobx-react'
import React, { useContext, useState } from 'react'
import { toast } from 'react-toastify'
import VirtualPortalComponent from './VirtualComponent'
import { useStore, useUiStore } from '../../hooks/use-store'

export const defaultContext = {
  notify: toast,
  component: null,
  store: null,
  uistore: null,
  routes: null,
  history: null,
  overridez: null,
  Component: VirtualPortalComponent
}

export const ComponentContext = React.createContext(defaultContext)

export const withContext = C => function wContext (props) {
  return <ComponentContext.Consumer>{ctx => <C {...props} ctx={ctx} />}</ComponentContext.Consumer>
}

export const ComponentProvider = observer(function ComponentProvider ({ children, ...value }) {
  const store = useStore()
  const uistore = useUiStore()

  const oldCtx = useContext(ComponentContext)
  function getDataSource (id) {
    return uistore?.dataSourceFactory?.dataSources.find(d => d.config.id === id)
  }
  function lookupRecords(key, refData) {
    return uistore?.dataSourceFactory?.lookupRecords(key, refData)
  }
   
  const [context] = useState({ ...oldCtx, store, uistore, getDataSource, lookupRecords, ...value })
  return (
    <ComponentContext.Provider value={context}>
      {children}
    </ComponentContext.Provider>
  )
})

export function useComponentContext () {
  return useContext(ComponentContext)
}
